import PodawaaLogo from "../assets/PodawaaLogo.svg";
import SkipcallLogo from "../assets/SkipcallLogo.svg";
import { CustomTFunction } from "../hooks/useTranslation/types.js";

export type CrossSellTranslations = {
    cross_sell: {
        discover: () => string;
        kawaak: {
            title: () => string;
            description: () => string;
            link: () => string;
        };
        podawaa: {
            title: () => string;
            description: () => string;
            link: () => string;
        };
        skipcall: {
            title: () => string;
            description: () => string;
            link: () => string;
        };
        kawaak_influence: {
            title: () => string;
            description: () => string;
            link: () => string;
        };
    };
};

export const getCrossSellProductsConfig = ({
    t,
    translations,
}: {
    t: CustomTFunction;
    translations: CrossSellTranslations;
}): Array<{ title: string; description: string; iconBackgroundColor: string; icon: string; link: string }> => [
    {
        title: t(translations.cross_sell.podawaa.title()),
        description: t(translations.cross_sell.podawaa.description()),
        icon: PodawaaLogo,
        iconBackgroundColor: "#E7EBF2",
        link: t(translations.cross_sell.podawaa.link()),
    },
    {
        title: t(translations.cross_sell.skipcall.title()),
        description: t(translations.cross_sell.skipcall.description()),
        icon: SkipcallLogo,
        iconBackgroundColor: "#E7F7F2",
        link: t(translations.cross_sell.skipcall.link()),
    },
];
